const initialState = {
  admins: [],
  admin: null,
  fleetUser: null,
  userFleets: [],
  userNewFleets: [],
  users: [],
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ADMINS": {
      state = {
        ...state,
        admins: action.payload,
      };
      return state;
    }
    case "SET_ADMIN": {
      state = {
        ...state,
        admin: action.payload,
      };
      return state;
    }
    case "SET_FLEET_USER": {
      state = {
        ...state,
        fleetUser: action.payload,
      };
      return state;
    }
    case "SET_USER_FLEETS": {
      state = {
        ...state,
        userFleets: action.payload,
      };
      return state;
    }
    case "SET_USER_NEW_FLEETS": {
      state = {
        ...state,
        userNewFleets: action.payload,
      };
      return state;
    }
    case "ADD_ADMIN": {
      state = {
        ...state,
        admins: [action.payload, ...state.admins],
      };
      return state;
    }
    case "UPDATE_ADMIN": {
      const updatedAdmins = state.admins.map((admin) => {
        if (admin.id == action.payload.id) {
          return action.payload;
        }
        return admin;
      });
      state = {
        ...state,
        admins: updatedAdmins,
      };
      return state;
    }
    case "DELETE_ADMIN": {
      const id = Number(action.payload);
      state = {
        ...state,
        admins: state.admins.filter((admin) => admin.id !== id),
      };
      return state;
    }
    case "SET_USERS": {
      state = {
        ...state,
        users: action.payload,
      };
      return state;
    }
    case "ADD_USER": {
      state = {
        ...state,
        users: [action.payload, ...state.users],
      };
      return state;
    }
    case "UPDATE_USER": {
      const updatedUsers = state.users.map((user) => {
        if (user.id === action.payload.id) {
          return action.payload;
        }
        return user;
      });
      state = {
        ...state,
        users: updatedUsers,
      };
      return state;
    }
    case "DELETE_USER": {
      state = {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
      };
      return state;
    }
    default:
      return state;
  }
}
